<template>
  <loading-overlay :loading="loading">
    <div class="details-table" :class="computedTableClass">

      <div v-if="title" class="details-table__header">
        <div class="details-table__header-inner">
          <div class="details-table__header-title" :style="{color: this.$themes.info}">{{ title }}</div>
          <div class="details-table__header-subtitle" v-html="subtitle"></div>
        </div>
      </div>
      <div v-if="title" class="details-table-hr"></div>

      <div class="details-table__body">
        <table>
          <thead>
            <tr class="details-table__body--table_headings">
              <th v-for="(item, index) in headings" :key="index">{{item}}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(row, rindex) in rows" :key="rindex">
              <td
                v-for="(item, cindex) in row"
                :key="cindex-rindex"
                :class="tdClass(cindex)"
                :style="tdStyle(item)"
                v-html="tdValue(item)"
              ></td>
            </tr>
          </tbody>
        </table>
      </div>

      <div v-if="headings2" class="details-table__body" style="margin-top:-0.2rem;">
        <table>
          <thead>
            <tr class="details-table__body--table_headings">
              <th v-for="(item, index) in headings2" :key="index">{{item}}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(row, rindex) in rows2" :key="rindex">
              <td
                v-for="(item, cindex) in row"
                :key="cindex-rindex"
                :class="tdClass(cindex)"
                v-html="item"
              ></td>
            </tr>
          </tbody>
        </table>
      </div>

    </div>
  </loading-overlay>
</template>

<script>
import LoadingOverlay from './LoadingOverlay'

export default {
  name: 'details-table',
  components: {
    LoadingOverlay,
  },

  props: {
    title: {
      type: String,
      required: false,
    },
    subtitle: {
      type: String,
      required: false,
    },
    headings: {
      type: Array,
      required: true,
    },
    rows: {
      type: Array,
      required: true,
    },

    headings2: {
      type: Array,
      required: false,
    },
    rows2: {
      type: Array,
      required: false,
    },

    loading: {
      type: Boolean,
      required: true,
    },
    striped: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
  data () {
    return {
    }
  },
  computed: {
    computedStripeStyle () {
      return {
        background: this.$themes && this.$themes[this.stripe] ? this.$themes[this.stripe] : this.stripe,
      }
    },
    computedTableClass () {
      if (this.striped) {
        return 'details-table__body--striped'
      }
      return ''
    },
  },
  methods: {
    tdClass (cindex) {
      if (cindex === 0) {
        return 'details-table__body--table_headings'
      }
      return ''
    },
    tdStyle (item) {
      if (item !== null && typeof item === 'object') {
        return `color: ${item.color}`
      }
      return ''
    },
    tdValue (item) {
      if (item !== null && typeof item === 'object') {
        return item.value
      }
      return item
    },
  },
}
</script>

<style lang="scss">
@import "../vuestic-sass/resources/resources";

.details-table {
  border-radius: $card-border-radius;
  border: none;
  box-sizing: border-box;
  box-shadow: $card-box-shadow;
  word-wrap: break-word;
  background-color: $white;
  position: relative;
  overflow: hidden;
  color: black;
  text-align: right;

  table {
    margin: auto;
  }

  &__header {
    &-inner {
      //display: flex;
      padding: 0.5rem 1.25rem 0rem 1.25rem;
      // min-height: 3.5rem;
      align-items: center;
    }

    &-title {
      font-weight: $font-weight-bold;
      font-size: $card-title-font-size;
      letter-spacing: $card-title-letter-spacing;
      text-transform: uppercase;
      text-align: left;
    }
    &-subtitle {
      font-size: small;
      text-align: left;
    }

    &-actions {
      margin-left: auto;
      flex: 0 0 auto;
    }

    &--over {
      position: absolute;
      padding-top: 56%;
      width: 100%;
      top: 0;
      left: 0;

      &:last-child {
        height: 100%;
      }

      & > div {
        position: absolute;
        width: 100%;
        bottom: 0;
        left: 0;
      }
    }
  }
  .details-table-hr {
    // content: '';
    // position: absolute;
    // top: 20px;
    // left: 0px;
    width: 100%;
    height: 0.2rem;
    background: #637f8c;
  }

  &__body {
    padding: 0.5rem $card-padding 0.5rem $card-padding;
    flex: 1 1 auto;
    overflow-x: auto;
    &--striped {
      tr {
        &:nth-child(even) {
          td {
            background-color: #E7EFFF;
          }
        }
      }
    }

    &--no-padding-v {
      padding: 0 $card-padding;
    }

    &--no-padding-h {
      padding: $card-padding 0;
    }

    &--no-padding {
      padding: 0;
    }

    &--padding-top {
      padding-top: 0.5rem;
    }

    &--table_headings {
      color: #8694a2;
    }

    td, th {
      padding-left: 10px;
    }

  }

  &__image {
     padding-bottom: 56%;
     position: relative;
     height: auto;
     min-height: 100%;

    img {
      position: absolute;
      top: 0;
      left: 0;
      height: 100%;
      width: 100%;
      display: block;
      object-fit: cover;
    }

    &-overlay {
      position: absolute;
      top: 0;
      left: 0;
      height: 100%;
      width: 100%;
      background-color: rgba(0, 0, 0, .3);
      pointer-events: none;
    }
  }

  &__stripe {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 0.5rem;
    z-index: 1;
  }
}
</style>
